import { useAppService, useInvalidateSaleQueries } from "@fero/hooks";
import { useMutation } from "@tanstack/react-query";
import type { EditPurchaseRequestReq } from "adl-gen/ferovinum/app/api";

export const useAmendTradeSaleMutation = () => {
  const service = useAppService();
  const invalidateQueries = useInvalidateSaleQueries();

  return useMutation({
    mutationFn: (editPurchaseRequestReq: EditPurchaseRequestReq) =>
      service.editPurchaseRequest(editPurchaseRequestReq),
    onSuccess: () => {
      invalidateQueries.invalidateAllQueries();
    },
  });
};
